const TABS = ['Favorites', 'Uploads']; // const TABS = ['Favorites', 'Frames', 'Uploads'];

function TabSelector({ currentTab, setTab }) {
	return (
		<div className="container">
            <header className="d-flex justify-content-center">
                <ul className="nav nav-pills">
                    {TABS.map(tab => (
                        <li
                            key={tab}
                            className={`nav-item btn mx-2 ${currentTab === tab ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => setTab(tab)}
                        >
                            {tab}
                        </li>
                    ))}
                </ul>
            </header>
		</div>
        
	);
}

export default TabSelector;